import { useTranslation } from "react-i18next";
import type { Extraction } from "../../../api/knowledgeData/knowledgeDataDecoders";
import type { AnnotationSet } from "../../../api/threads/liveMessages";
import AnnotationSetView from "../../annotation/AnnotationSetView";
import ABoxView from "../abox/ABoxView";
import ProvenancePanel from "../provenance/ProvenancePanel";

/**
 * One extraction result as every place shows it (F84 H-21): instance data in its one view,
 * `ABoxView`; annotations in the one span view the Threads use, with the result's
 * provenance. The result's page and its acceptance step show it alike.
 */
export default function ResultView({ extraction }: { extraction: Extraction }) {
  const { t } = useTranslation();
  if (extraction.instanceStatements.length > 0) return <ABoxView key={extraction.source} extraction={extraction} />;
  return (
    <section className="app-card space-y-3 p-3" aria-label={t("data.extraction.title")}>
      <AnnotationSetView output={annotationSetOf(extraction)} />
      <h3 className="app-title text-base font-semibold">{t("data.provenance.title")}</h3>
      <ProvenancePanel extraction={extraction} />
    </section>
  );
}

/** An annotation result as the span view draws it, the Thread's own form (W-6). */
function annotationSetOf(extraction: Extraction): AnnotationSet {
  return {
    output_kind: "annotations",
    document: extraction.document,
    label_list: extraction.labelList ?? "",
    annotations: extraction.statements.map(({ segment, start, end, quote, label, note }) => ({ segment, start, end, quote, label, note })),
  };
}
